<template>
    <div>{{ $options.name }}</div>
</template>

<script>
export default {
    name: "SiteEdit"
}
</script>

<style scoped>

</style>
